import React from 'react';

const InfoIcon = ({tooltipText}) => {
    const [showTooltip, setShowTooltip] = React.useState(false);

    return (
        <div
            style={{
                width: '30px',
                height: '30px',
                backgroundColor: 'transparent',
                position: 'relative',
                top: '0%',
                left: '10px',
                display: 'inline-block',
            }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
    <span
        style={{
            cursor: 'pointer',
            position: 'relative',
                    display: 'inline-block',
                    top: '-60%',
                    left: '25px',
        }}
    >
      <span
          style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#866bd9',
                        color: 'white',
                        width: '30px',
                        height: '30px',
              borderRadius: '4px',
              padding: '8px',
                        fontSize: '14px',
              lineHeight: '15px',
                        zIndex: 1,
                        display: "grid",
                        placeItems: "center",
                        fontWeight: "bold"
          }}
      >
        ?
      </span>
    </span>
            {showTooltip && (
                <div
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        width: 'max-content',
                        maxWidth: '300px',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#fff',
                        color: '#333',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '8px',
                        fontSize: '14px',
                        zIndex: 1,
                        boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.25)',
                    }}
                >
                    {tooltipText}
                </div>
            )}
        </div>
    );

};


export default InfoIcon;
